module.exports = __webpack_public_path__ + "static/media/SQL.1e8ee24b.png";